import * as t from 'io-ts';

import {makeApiType, makeEnumRuntimeType, RLazyTeammateIdRef} from './apiTypes';

/*
 * Constants.
 */

export enum CommentReactionErrorTypesEnum {
  MAX_PER_TEAMMATE = 'max_reactions_per_teammate',
  MAX_UNIQUE = 'max_unique_reactions_per_resource',
  MAX_UPVOTES = 'max_teammates_per_reaction',
}

/*
 * Runtime type.
 */

const RCommentReactionDirty = t.readonly(
  t.type({
    createdAt: t.Integer,
    groupCreatedAt: t.Integer,
    teammateId: RLazyTeammateIdRef,
    emojiString: t.string,
  }),
);

const RCommentReactionErrorType = makeEnumRuntimeType(CommentReactionErrorTypesEnum);

const RCommentReactionErrorDirty = t.readonly(
  t.type({
    type: RCommentReactionErrorType,
    id: t.string,
  }),
);

const RApiCommentReactionDirty = t.readonly(
  t.type({
    type: RCommentReactionErrorType,
  }),
);

/*
 * API type.
 */

export const ApiCommentReactionError = makeApiType(
  'commentReactionError',
  RApiCommentReactionDirty,
  parseCommentReactionError,
);

/*
 * Type.
 */

export interface CommentReactionModel extends t.TypeOf<typeof RCommentReactionDirty> {}
export const RCommentReaction = t.clean<CommentReactionModel>(RCommentReactionDirty as any);
export interface CommentReactionErrorModel extends t.TypeOf<typeof RCommentReactionErrorDirty> {}
export const RCommentReactionError = t.clean<CommentReactionErrorModel>(RCommentReactionErrorDirty as any);

export function parseCommentReaction(src: any) {
  return {
    createdAt: src.created_at || Date.now(),
    groupCreatedAt: src.reaction_group_created_at || Date.now(),
    teammateId: src.teammate_id,
    emojiString: src.reaction,
  };
}

function parseCommentReactionError(src: any) {
  return {
    type: src.status,
  };
}
